import { useState, type FormEvent } from "react";

export default function Newsletter() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const email = (formData.get("email") as string | null)?.trim() ?? "";

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus("error");
      setMessage("Please enter a valid email address.");
      return;
    }

    const params = new URLSearchParams();
    formData.forEach((v, k) => params.append(k, String(v)));

    try {
      setStatus("loading");
      setMessage("");
      const res = await fetch("https://readdy.ai/api/form/d8p1krvij7vns5otj48g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });
      if (!res.ok) throw new Error("Network error");
      setStatus("success");
      setMessage("You're in. Welcome to PureNest.");
      form.reset();
    } catch {
      setStatus("error");
      setMessage("Something went wrong. Please try again.");
    }
  }

  return (
    <section className="bg-primary-50 px-4 md:px-10 py-16 md:py-20">
      <div className="rounded-3xl bg-primary-900 text-background-50 px-6 md:px-12 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-7">
          <p className="text-xs uppercase tracking-widest text-accent-300 mb-4">The PureNest Letter</p>
          <h3 className="font-heading text-3xl md:text-5xl font-medium leading-[1.05]">
            Tiny cleaning rituals, fewer chores, a calmer home — once a month.
          </h3>
        </div>

        <div className="lg:col-span-5">
          <form
            id="newsletter-d8p1krvij7vns5otj48g"
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3"
          >
            <input
              type="email"
              name="email"
              required
              placeholder="your@email.com"
              className="flex-1 bg-background-50 text-foreground-900 placeholder-foreground-500 rounded-full px-5 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-accent-400"
            />
            <button
              type="submit"
              disabled={status === "loading"}
              className="inline-flex items-center justify-center gap-2 bg-accent-500 hover:bg-accent-600 disabled:opacity-60 text-background-50 px-6 py-3 rounded-full text-sm font-medium whitespace-nowrap transition-colors"
            >
              {status === "loading" ? "Subscribing…" : "Subscribe"}
              <i className="ri-arrow-right-line"></i>
            </button>
          </form>
          {message && (
            <p
              className={`mt-4 text-sm ${
                status === "success" ? "text-accent-300" : "text-secondary-300"
              }`}
            >
              {message}
            </p>
          )}
          <p className="mt-4 text-xs text-background-100/70">
            No spam, ever. Unsubscribe anytime.
          </p>
        </div>
      </div>
    </section>
  );
}